import { List, Create, Edit } from "../Components/index";

export default [
    {
        path: "/ere-users",
        component: List,
        name: "ere-users-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/ere-users/:id/edit",
        component: Edit,
        name: "ere-users-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/ere-users/create",
        component: Create,
        name: "ere-users-create",
        meta: {
            requiresAuth: true,
        },
    },
];
